import * as React from 'react'
import {
  Divider,
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  Icon,
} from '@material-ui/core'
import { Router } from 'routes'

type LinkData = {
  title: string
  destRoute: string
}
export type LinkListData = Array<LinkData>

export default function LinkList({
  linkListData,
}: {
  linkListData: LinkListData
}) {
  return (
    <List>
      {linkListData.map(({ title, destRoute }, index) => (
        <React.Fragment key={destRoute}>
          <ArrowListItem
            title={title}
            onClick={() => Router.pushRoute(destRoute)}
          />
          {index !== linkListData.length - 1 && <Divider />}
        </React.Fragment>
      ))}
    </List>
  )
}

const ArrowListItem = ({ title, onClick }) => {
  return (
    <ListItem button onClick={onClick}>
      <ListItemText primary={title} />
      <ListItemSecondaryAction>
        <Icon>chevron_right</Icon>
      </ListItemSecondaryAction>
    </ListItem>
  )
}

export function translateLinkTitle(t: (index: string) => string) {
  return (linkListData: LinkListData): LinkListData =>
    linkListData.map(linkData => ({ ...linkData, title: t(linkData.title) }))
}
